import { useEffect, useState } from 'react';
import apiService from '../../axios/apiService';

export const useAllRadiologistList = () => {
  const [data, setData] = useState();
  const getList = async (params) => {
    // Fetch users list
    const list = await apiService.getAllRadiologist(params);
    list && setData(list); // update data state
    return list;
  };

  useEffect(() => {
    console.log("data : ", data);
  },[data]);

  return {
    data,
    getList,
  };
};
